import { getLoginRedirectPath, getWorkbenchPath, ensureWorkbenchRoute } from '@/utils/workbench'
import router from './router'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isHttp, isPathMatch } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'

NProgress.configure({ showSpinner: false })

const whiteList = [
    '/login',
    '/register',
    '/userregister',
    '/news',
    '/news/newscontent',
    '/encyclopedia',
    '/encyclopedia/content',
    '/airline',
    '/dsplace',
    '/hzregister',
    '/gysregister',
    '/loginbmd',
    '/houtai',
    '/gzh',
    '/productDetails'
]

const isWhiteList = (path) => {
    return whiteList.some(pattern => isPathMatch(pattern, path))
}
// JavaScript 示例（其他语言可直接复用正则核心）
const domainRegex =
    /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

// 测试示例
function isLegalDomain(domain) {
    // 先处理大小写（统一转小写）和前后空格
    const cleanDomain = domain.trim().toLowerCase();
    // 1. 校验总长度（不超过253字符）
    if (cleanDomain.length > 253) return false;
    // 2. 用正则匹配格式
    return domainRegex.test(cleanDomain);
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (getToken()) {
        if (getLoginRedirectPath(to.path) !== to.path) return next({ path: '/workbench', replace: true })
        let sessionRoles = []
        try {
            const storedRoles = JSON.parse(sessionStorage.getItem('roles') || '[]')
            sessionRoles = Array.isArray(storedRoles) ? storedRoles : []
        } catch (error) {
            sessionRoles = []
        }
        to.meta.title && useSettingsStore().setTitle(to.meta.title)
        /* has token*/
        if ((sessionRoles[0] == "wlqy_dsh" || sessionRoles[0] == "hz_drz") && to.path == '/index') {
            return next({
                path: '/pc/authentication',
            });
        }
        if (to.path === '/login') {
            next({ path: '/workbench' })
            NProgress.done()
        } else if (isWhiteList(to.path)) {
            next()
        } else {
            if (useUserStore().roles.length === 0) {
                isRelogin.show = true
                // 判断当前用户是否已拉取完user_info信息
                useUserStore().getInfo().then(() => {
                    isRelogin.show = false
                    usePermissionStore().generateRoutes().then(accessRoutes => {
                        // 根据roles权限生成可访问的路由表
                        accessRoutes.forEach(route => {
                            if (!isHttp(route.path)) {
                                router.addRoute(route) // 动态添加可访问路由表
                            }
                        })
                        const user = useUserStore()
                        ensureWorkbenchRoute(router, getWorkbenchPath(user.rolesData, user.permissions))
                        next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
                    })
                }).catch(err => {
                    useUserStore().resetToken().then(() => {
                        ElMessage.error(err)
                        next({ path: '/login', query: { redirect: to.fullPath } })
                    })
                })
            } else {
                next()
            }
        }
    } else {
        // 没有token
        if (isWhiteList(to.path)) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next({ path: '/login', query: { redirect: to.fullPath } })
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
